import { Outlet } from 'react-router';

/**
 * Layout wrapper for public portal pages (landing, login, verify, etc.)
 *
 * Sets the themed background, Inter font as default, and selection styling
 * that is shared across all public portal pages. Follows the app theme.
 */
export function PortalPublicLayout() {
  return (
    <div className="min-h-screen bg-background font-sans selection:bg-brand selection:text-brand-foreground">
      <Outlet />
    </div>
  );
}
